import React from 'react'
import Skeleton from '../Skeleton/Skeleton'
import styles from './FilterSkeleton.module.css'

export default function FilterSkeleton() {
  return (
    <div className={styles.filterSkeleton}>
      <Skeleton
        width="6.25vw"
        height="2.08vw"
        variant="rounded"
        className={styles.buttonSkeleton}
      />
    </div>
  )
}
